export default __webpack_public_path__ + "static/media/calibra-cemente.61511bd8.png";